import type { CryptoAsset } from "~/types/assets.types";
import { calculateCryptoCoinProfitRates } from "./profit";
import { calculateCryptoYears } from "./years";

export const calculateCryptoYearlyYield = (userProduct: CryptoAsset) => {
  const coins = userProduct?.cryptoData || [];
  const coinProfitRates = calculateCryptoCoinProfitRates(userProduct);
  const cryptoYears = calculateCryptoYears(userProduct);

  return coins.map((_, index) => {
    const coinProfitRate = coinProfitRates?.[index] || 0;
    const years = cryptoYears?.[index] || 0;

    if (Number(years) === 0) return 0;
    return coinProfitRate / years;
  });
};
